// 统一管理错误码
export const errCodeMap = {
  0xC98005004: '请输入正确的验证码',
  0xE08001001: '验证码异常',
  0xE08101010: '短信发送失败',
  0xE08101004: '连接服务异常, 请稍后重试',
  0xE08101001: '发送过于频繁，请稍后再试',
  0xE0810100F: '验证码异常',
  0xE08101003: '异常',
  0xA16001005: '请输入正确的员工工号',
  0xA16001001: '已经领取过啦',
  0xA16001002: '验证码错误',
  0xA16001003: '优惠券不足',
  0xA16001004: '优惠券异常',
  0xE10001003: '员工号错误',
  0xA16001007: '活动还没有开始',
  0xA16001006: '活动已经过期了哦',
  0xA22006001: '活动不存在或者已被删除',
  0xA22006002: '活动未开始，请稍后再来',
  0xA22006003: '活动已结束，下次再来',
  0xA22006004: 'activity rule setting invalid',
  // 特殊处理
  0xA22006005: 'user dose not meet activity rule',
  0xA22006006: '系统异常',
  0xA22006007: 'activity member not found',
  // 0xE08001001: '图形验证码输入错误',
  0xE08001002: '所获取的图形验证码无效',
  // 0xE08101001: '获取短信验证码次数超过限制',
  0xE08101002: '所获取的短信验证码类型无效',
  // 0xE08101003: '无法获取上级短信网关的回复',
  // 0xE08101004: '没有可以使用的短信服务商',
  0xE08101005: '没有可用的短信服务商配置文件'
}
